


const atencionRecetaLS = localStorage.getItem('atencionReceta')
  ? JSON.parse(localStorage.getItem('atencionReceta'))
  : [];
  
export default {
  state:{
    medicamentosList: atencionRecetaLS,
    alergias : null
  },

  
  mutations: {
    setAlergias( state, data) {
      state.alergias = data
    },
    setMedicamentosList( state, data) {
      state.medicamentosList = data
    },

    resetReceta( state ) {
      state.medicamentosList = []
    }
  }
}

